import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import style from "../../../assets/css/styles.module.scss";

const cx = classNames;

const InputWrapper = ({
  children,
  className,
  isValid,
  errorMsg,
  label,
  labelClassName,
  afterInputText,
  id,
  labelClick
}) => {
  const wrapperStyles = cx([style.uiKitInputWrapper], className);

  const labelClickParam = labelClick ? { onClick: labelClick } : null;
  const labelClass = labelClassName ? { className: labelClassName } : null;
  return (
    <div className={wrapperStyles} id={id}>
      <div className={style.labelColumn}>
        <label {...labelClickParam} {...labelClass}>
          {label}
        </label>
      </div>

      <div className={`${style.inputColumn} inputColumn`}>
        {children}
        {afterInputText && <span className={style.afterInputText}>{afterInputText}</span>}
        {isValid === false && <span className={style.error}>{errorMsg}</span>}
      </div>
    </div>
  );
};

InputWrapper.displayName = "InputWrapper";

InputWrapper.defaultProps = {
  children: null,
  className: "",
  errorMsg: null,
  isValid: null,
  label: null,
  labelClassName: null,
  afterInputText: null,
  id: "",
  labelClick: null
};

InputWrapper.propTypes = {
  id: PropTypes.string,
  children: PropTypes.element,
  className: PropTypes.string,
  errorMsg: PropTypes.string,
  isValid: PropTypes.bool,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  afterInputText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  labelClick: PropTypes.func
};

export default InputWrapper;
